module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"drop-here":"Drop a file here to upload"},"fr_FR":{"drop-here":"Déposer un fichier ici pour le téléverser"}}')
  delete Component.options._Ctor
}
